import { render, staticRenderFns } from "./ReportCall.vue?vue&type=template&id=6fa8162c&"
import script from "./ReportCall.vue?vue&type=script&lang=js&"
export * from "./ReportCall.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports